module.exports = __webpack_public_path__ + "static/media/how-covid-19-is-changing-food-shopping.c31a1630.jpg";